import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Plugin } from 'prosemirror-state';
import { getIconItem } from '../../utils/menu';
import { imageUpload, setIsThumbnail, setAlignment } from './actions';
import pluginKey from './pluginKey';
import { getImageNode } from './nodes/image';
import './Image.scss';
import { removeSelectedNodeByPlugin } from '../../utils';
import { ACCEPTED_FILE_TYPES } from '../../../../constants/Constants';
const getToolbarItems = options => [{
  id: 'show-thumbnail',
  label: __('Show Thumbnail'),
  title: __('Show Thumbnail'),
  onClick: setIsThumbnail(true)
}, {
  id: 'show-fullimage',
  label: __('Show Full Image'),
  title: __('Show Full Image'),
  onClick: setIsThumbnail(false)
}, {
  id: 'image-preview',
  icon: 'tap-icon-eye',
  title: __('Preview'),
  onClick: (state, dispatch, editorView, pluginState) => {
    const {
      src,
      alt,
      title
    } = pluginState.attrs || {};
    options.events.emit('previewImage', src, alt, title);
  }
}, {
  id: 'align-left',
  icon: 'tap-icon-editor-img-align-left',
  title: __('Align Left'),
  onClick: setAlignment('align-left')
}, {
  id: 'align-center',
  icon: 'tap-icon-editor-img-align-center',
  title: __('Align Center'),
  onClick: setAlignment('align-center')
}, {
  id: 'align-right',
  icon: 'tap-icon-editor-img-align-right',
  title: __('Align Right'),
  onClick: setAlignment('align-right')
}, {
  id: 'separator-wrap',
  separator: true
}, {
  id: 'wrap-left',
  icon: 'tap-icon-editor-wrap-left',
  title: __('Wrap Left'),
  onClick: setAlignment('wrap-left')
}, {
  id: 'wrap-right',
  icon: 'tap-icon-editor-wrap-right',
  title: __('Wrap Right'),
  onClick: setAlignment('wrap-right')
}, {
  id: 'wrap-inline',
  icon: 'tap-icon-editor-wrap-inline',
  title: __('Wrap Inline'),
  onClick: setAlignment('wrap-inline')
}, {
  id: 'separator-remove',
  separator: true
}, {
  id: 'remove',
  icon: 'tap-icon-delete-fill',
  title: __('Remove'),
  onClick: removeSelectedNodeByPlugin
}];
const getImagePosition = state => {
  const imageNode = state.schema.nodes.image;
  const node = state.doc.nodeAt(state.selection.$from.pos);
  return node && node.type === imageNode ? state.selection.$from.pos : null;
};
const onFilter = (view, pluginState, items) => {
  const node = view.state.doc.nodeAt(pluginState.pos);
  return items.filter(item => item.id !== (node.attrs.useThumbnail ? 'show-thumbnail' : 'show-fullimage'));
};
export default {
  name: 'image',
  defaultOptions: {
    inline: true
  },
  configure: options => ({
    nodes: {
      image: getImageNode(_objectSpread(_objectSpread({}, options.nodeAttrs), {}, {
        hasInlineStyles: options.hasInlineStyles
      }))
    },
    menuItems: [getIconItem('toggle-image', 'icon-attach', 'Insert Image', null, {
      render: editorView => /*#__PURE__*/React.createElement("input", {
        type: "file",
        accept: ACCEPTED_FILE_TYPES,
        className: "tap-menu-fileupload",
        onChange: e => imageUpload(editorView, options, e)
      })
    })],
    plugin: new Plugin({
      key: pluginKey,
      state: {
        init: (_, state) => ({
          pos: getImagePosition(state),
          attrs: {},
          activeToolbarItem: 'wrap-inline'
        }),
        apply: (tr, pluginState, _oldState, newState) => {
          if (tr.docChanged || tr.selectionSet) {
            const pos = getImagePosition(newState);
            const node = pos ? newState.doc.nodeAt(pos) : null;
            const newPluginState = _objectSpread(_objectSpread({}, pluginState), {}, {
              pos,
              attrs: node ? node.attrs : {},
              activeToolbarItem: node ? node.attrs.alignment : ''
            });
            return newPluginState;
          }
          return pluginState;
        }
      }
    }),
    floatingToolbars: [{
      pluginKey,
      info: {
        items: getToolbarItems(options),
        inline: true,
        onFilter
      }
    }]
  })
};